import { Injectable } from '@angular/core';
import { IIconService } from 'interfaces-lib';
import { Observable, of } from 'rxjs';

export function normalizeHexColor(color: string | undefined): string | null {
  const trimmed = color?.trim();
  if (!trimmed) {
    return null;
  }
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
}

@Injectable({ providedIn: 'root' })
export class SalesforceIconService implements IIconService {
  private readonly failedIconUrls = new Set<string>();

  getIcon(type: string): string {
    type = type?.toLowerCase();
    if (!type) {
      return 'brc-icon brc-custom-object';
    }
    if (type.includes('contact')) {
      return 'brc-icon brc-contact';
    }
    if (type.includes('account')) {
      return 'brc-icon brc-account';
    }
    if (type.includes('job')) {
      return 'brc-icon brc-job';
    }
    if (type.includes('placement') || type.includes('closing')) {
      return 'brc-icon brc-closing-report';
    }
    if (type.includes('application')) {
      return 'brc-icon brc-application';
    }
    if (type === 'namespace') {
      return 'brc-icon brc-salesforce';
    }
    return 'brc-icon brc-custom-object';
  }

  resolveIconUrl$(iconUrl: string | undefined): Observable<string | null> {
    const normalized = iconUrl?.trim();
    if (!normalized || this.failedIconUrls.has(normalized)) {
      return of(null);
    }
    return of(normalized);
  }

  markIconUrlFailed(iconUrl: string | undefined): void {
    const normalized = iconUrl?.trim();
    if (!normalized) {
      return;
    }
    this.failedIconUrls.add(normalized);
  }
}
